import React from "react";
import { Field } from "redux-form";
import { FormInput, FormRow } from "MODULES/shared/components/Forms";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

export function Contact({ path, required }) {
  return (
    <div>
      <FormRow>
        <Col md={4}>
          <Field
            name={`${path}_name`}
            component={FormInput}
            label="Contact Name"
            required={required}
          />
        </Col>
        <Col md={4}>
          <Field
            name={`${path}_phone`}
            component={FormInput}
            label="Contact Telephone"
          />
        </Col>
        <Col md={4}>
          <Field
            name={`${path}_email`}
            component={FormInput}
            label="Contact Email"
            required={required}
          />
        </Col>
      </FormRow>
    </div>
  );
}

Contact.propTypes = {
  path: PropTypes.string
};

export default Contact;



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/Contact.jsx